var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tag_fill 1",
    clipPath: "url(#clip0_169_8519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE9\xA1\xB5\xE9\x9D\xA2-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Business"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tag_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.02477 1.44289C7.57037 1.39328 8.11035 1.56977 8.52032 1.92732L8.62004 2.02046L13.8353 7.23575C14.5851 7.98551 14.6151 9.18255 13.9253 9.96815L13.8353 10.0641L10.064 13.8354C9.31428 14.5852 8.11724 14.6152 7.33163 13.9254L7.23564 13.8354L2.02037 8.62015C1.63294 8.2327 1.42284 7.70489 1.43508 7.16104L1.44279 7.02481L1.75707 3.56787C1.84083 2.64643 2.54397 1.9084 3.44867 1.77156L3.56778 1.75716L7.02477 1.44289ZM5.34936 5.35012C4.82866 5.87082 4.82866 6.71501 5.34936 7.23575C5.87006 7.75641 6.7143 7.75641 7.23497 7.23575C7.7557 6.71501 7.7557 5.87082 7.23497 5.35012C6.7143 4.82942 5.87006 4.82942 5.34936 5.35012Z",
    fill: "#81298F"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_8519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.8afa51e733c103fdaf9468507c06cc63.svg";
export { ForwardRef as ReactComponent };